export const ReservationTypes = Object.freeze({
  FULL_TICKET: {
    key: 'F',
    value: 'Full ticket (full berth)',
    val: true,
  },
  HALF_TICKET: {
    key: 'H',
    value: 'Half ticket (no berth)',
    val: false,
  },
});

export const getReservationTypeOptions = () =>
  Object.values(ReservationTypes).map((reservationType) => ({
    id: reservationType.key,
    text: reservationType.value,
    obj: reservationType,
  }));
